import React, {Component} from 'react'
import {connect} from 'react-redux'
import Wrapper from '../common/Wrapper'
import Submenu from '../common/Submenu'
import DialogsList from './components/DialogsList/DialogsList'
// import DialogsList from './DialogsList'
import MessagesList from './components/MessagesList/MessagesList'
import {supportLoadStateSelector, uploadSupportChat} from '../../modules/support'
import cn from 'classnames'


class Support extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
        selectedDialog: null
      }
    }
    render() {
        const {selectedDialog} = this.state;
        return (
            <Wrapper renderButtonNav = {false}>
                <div className="container content flex-column container-support-wrapper">
                    <Submenu />
                    <div className={cn([
                        "support-wrapper",
                        "support-wrapper--flex-full-x-y",
                        "flex-1",
                        //"support-wrapper--indend-bottom",
                        "support-wrapper--height",
                    ])}>
                        <div className="support-wrapper__col support-wrapper__col--height support-wrapper__col--regulator support-wrapper__col--ovh-auto">
                            <DialogsList setSelectedDialog={(id) => this.setState({selectedDialog: id})} selectedDialog={selectedDialog}/>
                        </div>
                        <div className="support-wrapper__col support-wrapper__col--default support-wrapper__col--height support-wrapper__col--flex-grow">
                            <MessagesList selectedDialog={selectedDialog} />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    // componentWillMount() {
    //     let {supportLoadState : {initLoading, initLoaded}, uploadSupportChat} = this.props
    //     if (!initLoading && !initLoaded) uploadSupportChat()
    // }
}

export default connect(
    state => ({
        supportLoadState : supportLoadStateSelector(state),
    }),
    {uploadSupportChat}
)(Support)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/index.js